"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInternationalPhone = require("react-international-phone");
var _inputUtils = require("../../utils/input-utils");
var _fieldStyledComponents = require("../../styles/styled-components/field-styled-components");
var _mobxReact = require("mobx-react");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var countries = _reactInternationalPhone.defaultCountries.filter(function (country) {
  var _parseCountry = (0, _reactInternationalPhone.parseCountry)(country),
    iso2 = _parseCountry.iso2;
  return !['BS', 'BY', 'BR', 'KY', 'CN', 'DO', 'EC', 'EG', 'SV', 'GU', 'GT', 'JO', 'LR', 'MY', 'MH', 'FM', 'MC', 'MZ', 'NZ', 'NI', 'PY', 'PE', 'PH', 'QA', 'CG', 'KN', 'LC', 'WS', 'SA', 'SG', 'KR', 'LK', 'TW', 'TH', 'TR', 'TM', 'UY', 'VE', 'VN', 'VI', 'IN', 'KW', 'PR'].includes(iso2.toUpperCase());
});
function PhoneField(_ref) {
  var title = _ref.title,
    form = _ref.form,
    field = _ref.field,
    hideError = _ref.hideError,
    placeholder = _ref.placeholder;
  var boundField = (0, _inputUtils.bindField)(form, field);
  return /*#__PURE__*/_react["default"].createElement(_styles.PhoneFieldWrapper, null, /*#__PURE__*/_react["default"].createElement(_fieldStyledComponents.Title, null, title), /*#__PURE__*/_react["default"].createElement(_reactInternationalPhone.PhoneInput, _extends({
    placeholder: placeholder,
    defaultCountry: "us",
    preferredCountries: ['us', 'ca', 'mx'],
    countries: countries
  }, boundField, {
    onChange: function onChange(phone) {
      return form.$(field).sync(phone);
    }
  })), !hideError && /*#__PURE__*/_react["default"].createElement(_fieldStyledComponents.Error, {
    visible: true
  }, boundField.error));
}
var _default = exports["default"] = (0, _mobxReact.observer)(PhoneField);
//# sourceMappingURL=index.js.map